/* eslint-disable import/no-named-as-default */
import React from 'react';
import { Col, Label, Row } from 'reactstrap';
import { useQuery } from '@apollo/client';
import moment from 'moment';
import CardWithTitle from 'components/CardWithTitle';
import Loader from 'components/common/Loader';
import { CATEGORY_LIST } from 'utils/CommonGraphQL';
import CategoryGradeTable from './components/CategoryGradeTable';

const CategoriesDetails = ({ categoryId }) => {
  const { data, loading, error } = useQuery(CATEGORY_LIST, {
    variables: {
      filter: [{ key: 'id', value: categoryId, type: 'INT', op: 'EQ' }],
    },
  });

  if (loading) return <Loader />;
  if (error) return `There is an error on this page : ${error.message} `;
  if (!data?.categoryList?.categoryList) return 'Category not available';

  const currentRowData = data.categoryList.categoryList[0];

  return (
    <div>
      <CardWithTitle title="" capitalize="text-capitalize">
        <div className="product-info-row mb-2 d-flex align-items-start align-items-lg-center position-relative">
          <Row className="mb-2 w-100 align-items-center">
            <Col xs={7} sm={5} md={4} lg={3}>
              <Label className="f-12 fw-medium text-gray  d-block mb-0 text-uppercase">
                Category Name
              </Label>
              <p className="f-12 mb-0">{currentRowData?.name}</p>
            </Col>
            <Col xs={5} sm={3} md={3} lg={2}>
              <Label className="f-12 fw-medium text-gray d-block mb-0 text-uppercase">
                Status
              </Label>
              <p className="f-12 mb-0 text-capitalize">
                {currentRowData.status || 'Not Available'}
              </p>
            </Col>
            <Col xs={7} sm={4} md={3} lg={3}>
              <Label className="f-12 fw-medium text-gray d-block mb-0 text-uppercase">
                Created on
              </Label>
              <p className="f-12 mb-0">
                {moment(currentRowData.createdAt).format(
                  'D MMM, YYYY HH:mm A',
                ) || 'Not Available'}
              </p>
            </Col>
          </Row>
        </div>
      </CardWithTitle>
      <CategoryGradeTable currentRowData={currentRowData} />
    </div>
  );
};

export default CategoriesDetails;
